var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://gramatica.usc.es/?lang=es"}},[_c('img',{staticClass:"float-left",staticStyle:{"max-width":"260px"},attrs:{"src":require('../images/gdoe_usc.svg'),"alt":"Logos de la USC y del Grupo de Gramática del Español"}})])}
var staticRenderFns = []

export { render, staticRenderFns }